import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { getBenef } from '../../../Store/storages/BeneficiarioStorage';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Agendar } from '../../../interfaces/entities/Agendar';
import { City } from '../../../interfaces/entities/City';
import { Doctor } from '../../../interfaces/entities/Doctor';
import { Horarios } from '../../../interfaces/entities/Horarios';
import { RetornaAceiteTermoTeleMedicina } from '../../../interfaces/entities/RetornaAceiteTermoTeleMedicina';
import { OrderingDocsEnum } from '../../../interfaces/enum/OrderingDocsEnum';
import { TypeScheduleTabsEnum } from '../../../interfaces/enum/TypeScheduleTabsEnum';
import { agendar, retornaAceiteTermoTeleMedicina } from '../../../services/SaudeOnlineService';
import Confirmacao from './Confirmacao';
import GuiaMedico from './GuiaMedico';
import Horario from './Horario';
import LocalDeExames from './LocalDeExames';
import ScheduleTabs from './ScheduleTabs';
import { defaultDoctor } from './defaultStates';
import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';


function AgendarConsulta() {

  const [step, setStep] = useState<string>(TypeScheduleTabsEnum.GuiaMedico);
  const [userType, setUserType] = useState<string>('');
  const [doctor, setDoctor] = useState<Doctor>(defaultDoctor);
  const [docsList, setDocsList] = useState<Doctor[]>([]);
  const [changeDocs, setChangeDocs] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedHour, setSelectedHour] = useState<Horarios | null>(null);
  const [typeOfAppointment, setTypeOfAppointment] = useState<string>('');
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [sortDocs, setSortDocs] = useState<boolean>(false);
  const [teleTerm, setTeleTerm] = useState<RetornaAceiteTermoTeleMedicina | null>(null);
  const [city, setCity] = useState<City | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const accessibility = useAccessibility();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const successMessage = `Aguarde a confirmação da clínica/consultório. Lembrando que, caso não seja possível o seu comparecimento, 
  favor cancelar a consulta com a maior antecedência possível para que este horário seja disponibilizado para outro cliente. A sua consulta, 
  ainda que confirmada, poderá sofrer atraso ou ser cancelada por motivos de força maior ou caso fortuito.`

  useEffect(() => {
    const getSaudeOnline = async () => {
      await getUser();
      await getTermsOfUse();
      setShowLoading(false);
    }

    const getUser = async () => {
      const benef = await getBenef()!;
      setUserType(benef.indClienteMais);
    }

    const getTermsOfUse = async () => {
      const result = await retornaAceiteTermoTeleMedicina();
      setTeleTerm(result);
    }

    setShowLoading(true);
    getSaudeOnline();

    if (location?.state?.doctorInfo) {
      setChangeDocs(true);
      setDocsList(location.state.doctorInfo);
    }

  }, []);

  const handleDoctor = (doc: Doctor, doctors: Doctor[]) => {
    setDoctor(doc);
    setDocsList(doctors)
    setStep(TypeScheduleTabsEnum.Horario);
  }

  const backStep = (newStep: TypeScheduleTabsEnum, update: boolean) => {
    if (step === TypeScheduleTabsEnum.Confirmacao && newStep === TypeScheduleTabsEnum.LocalDeExames) {
      if (typeOfAppointment === 'Presencial') {
        setStep(TypeScheduleTabsEnum.LocalDeExames);
      }
      else {
        setStep(TypeScheduleTabsEnum.Horario);
      }
    }
    else {
      setStep(newStep)
    }
    setChangeDocs(update)

    if (!update && newStep === TypeScheduleTabsEnum.GuiaMedico) {
      setDocsList([])
    }
    if (newStep === TypeScheduleTabsEnum.GuiaMedico) {
      setSelectedDate(null)
      setSelectedHour(null)
    }
  }

  const handleSchedule = (date: Date | null, hour: Horarios | null) => {
    setSelectedDate(date);
    setSelectedHour(hour);
    if (typeOfAppointment === 'Presencial') {
      setStep(TypeScheduleTabsEnum.LocalDeExames);
    }
    else {
      setStep(TypeScheduleTabsEnum.Confirmacao);
    }
  }

  const handleTypeOfAppointment = (type: string) => {
    setTypeOfAppointment(type)
  }

  const saveSchedule = async (tel: string, cel: string, email: string) => {
    setShowLoading(true);
    let body: Agendar;
    if (city !== null) {
      body = {
        idInstal: doctor.idInstal,
        idPrestador: doctor.idPessoa,
        espec: doctor.descrEspec,
        data: `${selectedHour?.data} ${selectedHour?.hora}`,
        idTipoAgendamento: typeOfAppointment.charAt(0),
        email,
        tel,
        cel,
        tipoAtend: typeOfAppointment.charAt(0),
        idCidadeExame: `${city.idCidade}`
      }
    }
    else {
      body = {
        idInstal: doctor.idInstal,
        idPrestador: doctor.idPessoa,
        espec: doctor.descrEspec,
        data: `${selectedHour?.data} ${selectedHour?.hora}`,
        idTipoAgendamento: typeOfAppointment.charAt(0),
        email,
        tel,
        cel,
        tipoAtend: typeOfAppointment.charAt(0),
        idCidadeExame: ''
      }
    }
    const result = await agendar(body);
    if (result === 'OK') {
      setShowLoading(false)
      openModal('success', 'A reserva do seu agendamento foi realizada com sucesso!', successMessage, 'FECHAR', handleCloseSchedule, handleCloseSchedule);
    }
    else {
      setShowLoading(false)
      openModal('error', 'Agendamento não realizado', `${result}`, 'VOLTAR', handleCloseModal, handleCloseModal);
    }
  }

  const openModal = (
    icon: 'error' | 'success' | 'warning', title: string, subtitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon: icon,
      title: title,
      subTitle: subtitle,
      textButton: textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const handleCloseSchedule = () => {
    setModalFeedback(null);
    navigate('/saudeOnline/meusAgendamentos');
    setSelectedDate(null);
    setSelectedHour(null);
  }

  const handleCloseModal = () => {
    setModalFeedback(null);
    navigate('/home');
  }

  const handleSort = (value: string, doctors: Doctor[]) => {
    switch (value) {
      case OrderingDocsEnum.Nome:
        const ordenedByName = doctors.sort((a, b) => a.nomePessoa.localeCompare(b.nomePessoa));

        setDocsList(ordenedByName)
        setSortDocs(!sortDocs)
        break;
      case OrderingDocsEnum.Data:
        let ordenedByData = doctors.sort((a, b) => {
          const dataA = new Date(
            parseInt(a.dtDispon.split('/')[2]),
            parseInt(a.dtDispon.split('/')[1]) - 1,
            parseInt(a.dtDispon.split('/')[0])
          );

          const dataB = new Date(
            parseInt(b.dtDispon.split('/')[2]),
            parseInt(b.dtDispon.split('/')[1]) - 1,
            parseInt(b.dtDispon.split('/')[0])
          );

          return dataA.getTime() - dataB.getTime();
        });
        setDocsList(ordenedByData);
        setSortDocs(!sortDocs)
        break;
      case OrderingDocsEnum.Distancia:
        const ordenedByDist = doctors.sort((a, b) => {

          if (a.distancia < b.distancia) {
            return -1;
          }
          if (a.distancia > b.distancia) {
            return 1;
          }
          return 0;
        });
        setDocsList(ordenedByDist);
        setSortDocs(!sortDocs)
        break;

      default:
        break;
    }

  }

  const handleLocalDeExames = (selectedCity?: City) => {
    if (selectedCity)
      setCity(selectedCity)
    setStep(TypeScheduleTabsEnum.Confirmacao);
  }

  return (
    <div className='schedule-appointment'>
      <LoadingApp showLoading={showLoading} />
      <PageTitle text="Agendar consulta" marginBottom="48px" />
      <ScheduleTabs step={step} backStep={backStep} />
      {step === TypeScheduleTabsEnum.GuiaMedico &&
        <GuiaMedico
          handleTypeOfAppointment={handleTypeOfAppointment}
          userType={userType}
          handleDoctor={handleDoctor}
          docsList={docsList}
          changeDocs={changeDocs}
          handleSort={handleSort}
          sortDocs={sortDocs} />
      }
      {step === TypeScheduleTabsEnum.Horario &&
        <Horario
          doctor={doctor}
          typeOfAppointment={typeOfAppointment}
          backStep={backStep}
          handleSchedule={handleSchedule}
          selectedDate={selectedDate}
          selectedHour={selectedHour}
          teleTerm={teleTerm} />
      }
      {step === TypeScheduleTabsEnum.LocalDeExames &&
        <LocalDeExames
          backStep={backStep}
          handleLocalDeExames={handleLocalDeExames} />
      }
      {step === TypeScheduleTabsEnum.Confirmacao &&
        <Confirmacao
          typeOfAppointment={typeOfAppointment}
          doctor={doctor}
          selectedDate={selectedDate}
          selectedHour={selectedHour}
          backStep={backStep}
          saveSchedule={saveSchedule} />
      }
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </div>
  )
}

export default AgendarConsulta